exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".kye-area-input-validate-error input {\n  border-color: #FF5555 !important; }\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/kye-area/style/validate.scss"],"names":[],"mappings":"AAAA;EACE,iCAAiC,EAAE","file":"validate.scss","sourcesContent":[".kye-area-input-validate-error input {\n  border-color: #FF5555 !important; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader??ref--10-2!./node_modules/postcss-loader/lib??ref--10-3!./node_modules/fast-sass-loader/lib??ref--10-4!./src/public/components/kye-area/style/validate.scss
// module id = fAA2
// module chunks = 6